import * as React from 'react';

interface RendererProps {
  childs: React.ReactNode;
}

type RendererType<P> = React.FC<RendererProps & P>;

type SlotProps<P> = {
  showChildren?: boolean;
  restProps?: P & { defaultChildren: React.ReactNode };
};

type NormalOrFunctionChildren<P> =
  | React.ReactNode
  | ((props: P & { defaultChildren: React.ReactNode }) => React.ReactNode);

export type SlotType<P> = {
  (props: SlotProps<P> & { children?: NormalOrFunctionChildren<P> }): React.ReactElement | null;
  Renderer: RendererType<P>;
};

export function useSlot<P extends {}>(): SlotType<P> {
  //@ts-ignore
  const Slot: SlotType<P> = ({ children, showChildren, restProps }) => {
    if (!showChildren) {
      return null;
    }
    if (typeof children === 'function' && restProps) {
      return children(restProps);
    }
    return <>{children}</>;
  };
  //@ts-ignore
  const Renderer: RendererType<P> = ({ childs, children, ...restProps }) => {
    const slotted = React.Children.toArray(childs).find((child) => {
      return React.isValidElement(child) && child.type === Slot;
    });

    if (!slotted || !React.isValidElement(slotted)) {
      return <>{children}</>;
    }
    return React.cloneElement(slotted, {
      showChildren: true,
      restProps: { ...restProps, defaultChildren: children },
    } as unknown as SlotProps<P>);
  };

  Slot.Renderer = Renderer;
  return Slot as SlotType<P>;
}
